import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";
import { ChiefUserComponent } from "@app/features-modules/chief-accountant/components/chief-user/chief-user.component";

@Injectable()
export class CanLogoutCAGuard implements CanDeactivate<ChiefUserComponent> {
  canDeactivate(
    component: ChiefUserComponent,
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot) {
    if ((nextState.url.indexOf('landing-page') > -1)) {
        return component.canLogout();
    } else {
        return true;
    }
  }
}
